module.exports = __webpack_public_path__ + "front/img/sub-img-2-wap.8b1a9626.png";